import { useSuspenseQuery } from "@tanstack/react-query";
import { listingsModel } from "models/listings";
import { useParams } from "react-router-dom";
import { useAuth } from "contexts/auth-provider";
import { usePortalPath } from "hooks/use-portal-path";

export const useRegion = () => {
  const { propertyId } = useParams();
  const { isLandlordOrTenantPath } = usePortalPath();
  const { user } = useAuth();

  const { data } = useSuspenseQuery(
    listingsModel.queries.readRegion(
      !isLandlordOrTenantPath ? propertyId : undefined,
    ),
  );

  if (isLandlordOrTenantPath) {
    return data?.id ?? "AUS";
  }

  return user?.region.id ?? "AUS";
};
